import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';

import BaseTrigger from 'triggers/BaseTrigger';

const baseString = 'vra-quit-flow-modal-trigger';
const classString = classNames({
  [`${baseString}`]: true
});
const QuitFlowModalTrigger = ({
  onClickCancel
}) => (
  <section className={classString}>
    <BaseTrigger
      content={getMessage('button-text__cancel')}
      dataTestId='quit-flow-modal-trigger'
      handler={onClickCancel}
    />
  </section>
);
QuitFlowModalTrigger.propTypes = {
  onClickCancel: PropTypes.func.isRequired
};
export default QuitFlowModalTrigger;
